// Intentionally empty JS file to allow unused/unusable
// modules to be satisfied via require

module.exports = {};
